const categoryKeys: Record<string, string> = {
    ALL: "전체보기",
    INTERIOR_DECORATION: "인테리어 & 장식용",
    PLANTER_GARDENING: "플랜테리어 / 정원용",
    STORAGE_ORGANIZATION: "보관 & 정리용",
    GIFTS_SOUVENIRS: "선물 & 기념품",
    TOOLS_FUNCTIONALITY: "도구 & 기능성",
    HOBBIES_PLAY: "취미 & 놀이",
    COMMERCIAL_BRANDING: "상업/브랜딩",
};

export default categoryKeys;
